<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <div class="tabs-widget">
        <div class="tab-item" @click="switchTab('transactions')">
          TRANSACTIONS
        </div>
        <div class="h-spacer"></div>
        <div class="tab-item" @click="switchTab('earning_report')">
          EARNING REPORT
        </div>
        <div class="h-spacer"></div>
        <div class="tab-item" @click="switchTab('tax')">TAX</div>
        <div class="h-spacer"></div>
        <div class="tab-item active" @click="switchTab('settlement')">
          SETTLEMENT
        </div>
      </div>
      <div class="tab-options">
        <b-button type="is-primary" outlined @click="showWithDrawModal()">ADD SETTLEMENT</b-button>
      </div>
    </div>
    <div class="wrapper-body">
      <div v-if="!loading_settlement && settlement_data" class="left-panel">
        <div class="table-widget">
          <b-button style="margin-bottom: 10px" type="is-primary" size="is-small" class="openButton"
            @click="rightPanel = true">View Balance</b-button>
          <table>
            <tr>
              <th>Amount</th>
              <th>Receiver</th>
              <th>Payment Type</th>
              <th>Reason</th>
              <th>Fee</th>
              <th>Status</th>
              <th>Date</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in settlement_data.data" :key="index">
              <td>RWF {{ item.amount }}</td>
              <td>{{ item.receiver }}</td>
              <td>
                <span v-if="item.payment == 'MOMO'">Mobile Moneny</span>
                <span v-if="item.payment == 'BANK'">Bank</span>
                <span v-if="item.payment == 'CASH'">Cash</span>
              </td>
              <td>
                {{ item.reason }}
              </td>
              <td>RWF {{ item.fee }}</td>
              <td>
                <b-tag v-if="item.status == 'payed'" type="is-success">PAYED</b-tag>
                <b-tag v-if="item.status == 'pending'" type="is-warning">Pending</b-tag>
              </td>
              <td>
                {{ moment(item.created_at).format("MMM DD YYYY HH:mm A") }}
              </td>
              <td>
                <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                  <template #trigger>
                    <b-icon icon="dots-vertical"></b-icon>
                  </template>
                  <b-dropdown-item aria-role="listitem" @click="updateSettlement(item)">Update</b-dropdown-item>
                  <b-dropdown-item @click="deleteSettlement(item)" aria-role="listitem">Delete</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div v-if="loading_settlement" class="left-panel">
        <div class="table-widget">
          <table>
            <tr>
              <th>Amount</th>
              <th>Receiver</th>
              <th>Payment Type</th>
              <th>Reason</th>
              <th>Fee</th>
              <th>Status</th>
              <th>Date</th>
              <th></th>
            </tr>
            <tr v-for="(item, index) in 15" :key="index">
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
              <td><b-skeleton width="90%"></b-skeleton></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="rigth-panel" :class="{ active: rightPanel }">
        <div class="rigth-panel-header" v-if="backBalanceData">

          <div class="rigth-panel-header-title">
            BALANCE AT BANK ACCOUNT
            <span @click="rightPanel = false">Close</span>
          </div>
          <div class="rigth-panel-header-banks-widget">
            <div class="bank-widget-item" v-if="backBalanceData.besoft.wallet_balance">
              <div class="bank-widget-title">
                BESOFT MOMO ACCOUNT
              </div>
              <div class="bank-widget-balance">
                {{ $formatMoney(backBalanceData.besoft.wallet_balance[0].amount) }}
              </div>
            </div>
            <div class="bank-widget-item">
              <div class="bank-widget-title">
                INTOUCH MOMO ACCOUNT
              </div>
              <div class="bank-widget-balance" v-if="backBalanceData.intouch">
                {{ $formatMoney(backBalanceData.intouch.balance) }}
              </div>
            </div>
            <div class="bank-widget-item">
              <div class="bank-widget-title">
                WECODEFY EQUITY BANK ACCOUNT
              </div>
              <div class="bank-widget-balance">
                Not Available
              </div>
            </div>
            <div class="bank-widget-item">
              <div class="bank-widget-title">
                TOTAL:
              </div>
              <div class="bank-widget-balance" v-if="backBalanceData.intouch">
                {{ $formatMoney(backBalanceData.besoft.wallet_balance ? backBalanceData.besoft.wallet_balance[0].amount
                  +
                  backBalanceData.intouch.balance :
                  backBalanceData.intouch.balance
                ) }}
              </div>
            </div>
          </div>
        </div>
        <div class="rigth-panel-body">

          <widgetCounter class="money-widget" title="Total Balance" :value="`${$formatMoney(total_balance)}`"
            @more="() => { }">
            <img src="@/assets/images/dashboard/Graph-1.svg" />
          </widgetCounter>
          <widgetCounter class="money-widget" title="Settled Balance" :value="`${$formatMoney(total_settled_balance)}`"
            @more="() => { }">
            <img src="@/assets/images/dashboard/Graph-2.svg" />
          </widgetCounter>
          <widgetCounter class="money-widget" title="Available Balance" :value="`${$formatMoney(left_balance)}`"
            @more="() => { }">
            <img src="@/assets/images/dashboard/Graph-4.svg" />
          </widgetCounter>
        </div>
      </div>
    </div>
    <div class="wrapper-footer">
      <b-pagination :total="pagination_options.total" v-model="pagination_options.current" @change="getSettlements"
        :range-before="pagination_options.rangeBefore" :range-after="pagination_options.rangeAfter"
        :order="pagination_options.order" :size="pagination_options.size" :simple="pagination_options.isSimple"
        :rounded="pagination_options.isRounded" :per-page="pagination_options.perPage"
        :icon-prev="pagination_options.prevIcon" :icon-next="pagination_options.nextIcon" aria-next-label="Next page"
        aria-previous-label="Previous page" aria-page-label="Page" aria-current-label="Current page"
        :page-input="pagination_options.hasInput" :page-input-position="pagination_options.inputPosition"
        :debounce-page-input="pagination_options.inputDebounce">
      </b-pagination>
    </div>

    <!-- Add settlement modal -->
    <b-modal v-model="show_add_settlement_modal" :id="'sideBar' + $store.state.sidebar">
      <div class="form-modal-widget">
        <div class="form-modal-header">
          <h2 v-if="!form.id">ADD SETTLEMENT</h2>
          <h2 v-else>UPDATE SETTLEMENT</h2>
        </div>
        <div class="form-modal-body">
          <div class="row" style="margin-bottom: 20px">
            <b-field style="width: 100%" label="Pay with">
              <b-select v-model="form.payWith" expanded>
                <option v-for="(option, index) in payWith" :key="index" :value="option.value">
                  {{ option.label }}
                </option>
              </b-select>
            </b-field>
            <div v-if="form.payWith != 'MOMO'" class="h-spacer"></div>
            <b-field v-if="form.payWith != 'MOMO'" style="width: 100%" label="Status">
              <b-select v-model="form.status" expanded>
                <option value="pending">Pending</option>
                <option value="payed">Payed</option>
              </b-select>
            </b-field>
          </div>
          <div class="row">
            <b-field label="Amount">
              <div class="row">
                <p class="control">
                  <span class="button is-static">RWF</span>
                </p>
                <b-numberinput v-model="form.amount" expanded min="1" controls-position="compact"></b-numberinput>
              </div>
            </b-field>
            <div class="h-spacer"></div>
            <b-field label="Fee Amount">
              <div class="row">
                <p class="control">
                  <span class="button is-static">RWF</span>
                </p>
                <b-numberinput v-model="form.fee" expanded min="1" controls-position="compact"></b-numberinput>
              </div>
            </b-field>
          </div>

          <b-field label="Receiver">
            <b-input v-model="form.receiver" value=""></b-input>
          </b-field>

          <b-field v-if="!form.id && form.payWith == 'MOMO'" label="Phone number(MTN)">
            <b-input v-model="form.phone" value=""></b-input>
          </b-field>

          <b-field v-if="!form.id && form.payWith == 'MOMO'" style="width: 100%" label="Payment provider">
            <b-select v-model="form.payProvider" expanded>
              <option v-for="(option, index) in payProvider" :key="index" :value="option.value">
                {{ option.label }}
              </option>
            </b-select>
          </b-field>

          <b-field label="Reason">
            <b-input v-model="form.reason" maxlength="200" type="textarea"></b-input>
          </b-field>
        </div>
        <div class="form-modal-footer">
          <b-button :loading="submit_settlement_loading" @click="confirmSettlement()" type="is-primary">SAVE</b-button>
          <div class="h-spacer"></div>
          <b-button @click="show_add_settlement_modal = false" type="is-primary" outlined>CANCEL</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  components: {},
  data: () => ({
    rightPanel: false,
    loading_settlement: false,
    show_add_settlement_modal: false,
    submit_settlement_loading: false,
    payWith: [
      { value: "MOMO", label: "MOBILE MONEY" },
      { value: "BANK", label: "BANK" },
      { value: "CASH", label: "CASH" },
    ],
    payProvider: [
      { value: "intouch", label: "Intouch Payment" },
      { value: "besoft", label: "BeSoft" },
    ],
    form: {
      id: null,
      payWith: "MOMO",
      payProvider: "intouch",
      status: "payed",
      amount: 0,
      fee: 0,
      receiver: "",
      phone: "",
      reason: "",
    },
    settlement_data: null,
    pagination_options: {
      total: 200,
      current: 1,
      perPage: 10,
      rangeBefore: 3,
      rangeAfter: 1,
      order: "",
      size: "",
      isSimple: false,
      isRounded: false,
      hasInput: false,
      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      inputPosition: "",
      inputDebounce: "",
    },
    left_balance: 0,
    total_balance: 0,
    total_settled_balance: 0,
    backBalanceData: null
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getSettlements();
    vm.getBalance();
  },
  methods: {
    getBalance() {
      let vm = this;
      vm.$store
        .dispatch("FINANCE_GET_BANK_BALANCE")
        .then((response) => {
          vm.backBalanceData = response.data.return;
        })
        .catch(({ response }) => {

        });
    },
    updateSettlement(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.payWith = item.payment;
      vm.form.status = item.status;
      vm.form.amount = item.amount;
      vm.form.fee = item.fee;
      vm.form.receiver = item.receiver;
      vm.form.reason = item.reason;
      vm.show_add_settlement_modal = true;
    },
    deleteSettlement(item) {
      let vm = this;
      vm.$confirm({
        title: "Confirm",
        message: `Are you sure?`,
        button: {
          no: "No",
          yes: "Yes",
        },
        callback: (confirm) => {
          if (confirm) {
            vm.$store
              .dispatch("FINANCE_SETTLEMENT_DELETE", { id: item.id })
              .then((response) => {
                vm.getSettlements();
                vm.$notify({
                  group: "status",
                  type: "success",
                  title: "Important message",
                  text: response.data.message,
                });
              })
              .catch(({ response }) => {
                vm.$notify({
                  group: "status",
                  type: "warn",
                  title: "OOPS!!!",
                  text: response.data.message,
                });
              });
          }
        },
      });
    },
    confirmSettlement() {
      let vm = this;
      if (vm.form.id || vm.left_balance > vm.form.amount + vm.form.fee) {
        vm.submitSettlement();
      } else {
        vm.$confirm({
          title: "Confirm",
          message: `You don't have enough funds to pay?, You want to continue?`,
          button: {
            no: "No",
            yes: "Yes",
          },
          callback: (confirm) => {
            if (confirm) {
              vm.submitSettlement();
            }
          },
        });
      }
    },
    submitSettlement() {
      let vm = this;
      vm.submit_settlement_loading = true;
      if (!vm.form.id) {
        vm.$store
          .dispatch("FINANCE_SETTLEMENT_ADDNEW", vm.form)
          .then((response) => {
            vm.show_add_settlement_modal = false;
            vm.submit_settlement_loading = false;
            vm.getSettlements();
            vm.$notify({
              group: "status",
              type: "success",
              title: "Message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_settlement_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      } else {
        vm.$store
          .dispatch("FINANCE_SETTLEMENT_UPDATE", vm.form)
          .then((response) => {
            vm.show_add_settlement_modal = false;
            vm.submit_settlement_loading = false;
            vm.getSettlements();
            vm.$notify({
              group: "status",
              type: "success",
              title: "Message",
              text: response.data.message,
            });
          })
          .catch(({ response }) => {
            vm.submit_settlement_loading = false;
            vm.$notify({
              group: "status",
              type: "warn",
              title: "OOPS!!!",
              text: response.data.message,
            });
          });
      }
    },
    getSettlements(page = 1) {
      let vm = this;
      vm.loading_settlement = true;
      vm.$store
        .dispatch("FINANCE_SETTLEMENT_GET_ALL", {
          page: page,
        })
        .then((response) => {
          vm.loading_settlement = false;
          vm.settlement_data = response.data.return;
          vm.pagination_options.total = vm.settlement_data.total;
          vm.pagination_options.current = vm.settlement_data.current_page;
          vm.pagination_options.perPage = vm.settlement_data.per_page;
          vm.left_balance = vm.settlement_data.left_balance;
          vm.total_balance = vm.settlement_data.total_balance;
          vm.total_settled_balance = vm.settlement_data.total_settled_balance;
        })
        .catch((error) => {
          vm.loading_settlement = false;
        });
    },
    showWithDrawModal() {
      let vm = this;
      vm.form = {
        id: null,
        payWith: "MOMO",
        payProvider: "intouch",
        status: "payed",
        amount: 0,
        fee: 0,
        receiver: "",
        phone: "",
        reason: "",
      };
      vm.show_add_settlement_modal = true;
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;
      margin-right: 15px;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        border-bottom: 3px solid transparent;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 125px);
    display: flex;
    position: relative;

    .left-panel {
      overflow-y: auto;
      height: 100%;
      width: calc(100% - 450px);
      display: flex;

      @media (max-width: 966px) {
        width: 50%;
      }

      @media (max-width: 700px) {
        width: 55%;
      }

      @media (max-width: 600px) {
        width: 100%;
      }

      .table-widget {
        // height: calc(100% - 60px);
        overflow-y: auto;
        border-radius: 0;

        button.openButton {
          display: none;
          width: fit-content;
          margin: 5px 0 0 5px;

          @media (max-width: 600px) {
            display: flex;
          }
        }

        table {
          width: 100%;

          tr {
            th {
              white-space: nowrap;
            }

            td {
              white-space: nowrap;

              .tag-lists {
                display: flex;
                width: fit-content;
                flex-shrink: 0;
                min-width: 170px;
              }
            }
          }
        }
      }
    }

    .rigth-panel {
      width: 450px;
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;

      @media (max-width: 966px) {
        width: 50%;
      }

      @media (max-width: 700px) {
        width: 45%;
      }

      @media (max-width: 600px) {
        position: absolute;
        background: white;
        top: 0;
        z-index: 999;
        top: 0;
        right: -450px;
        transition: .5s;
        width: 65%;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);

        &.active {
          right: 0;
        }
      }

      @media (max-width: 485px) {
        width: 80%;
      }

      .rigth-panel-header {
        .rigth-panel-header-title {
          font-size: 19px;
          font-weight: 600;
          margin-bottom: 10px;
          background: #ddd;
          padding: 0px 10px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          span {
            color: red;
            font-weight: 700;
            font-size: 16px;
            display: none;

            @media (max-width: 600px) {
              display: flex;
            }
          }
        }

        .rigth-panel-header-banks-widget {
          padding: 0px 10px;
          display: flex;
          flex-direction: column;
          border-bottom: 1px solid #ddd;

          .bank-widget-item {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 0px;
            border-bottom: 1px dashed #ddd;

            .bank-widget-title {
              font-size: 16px;
              font-weight: 600;
            }

            .bank-widget-balance {
              cursor: pointer;
              color: #038d6f;
            }
          }
        }
      }

      .rigth-panel-body {
        height: 100%;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        padding: 10px;

        .money-widget {
          margin-bottom: 10px;
          height: fit-content;
        }
      }
    }
  }

  .wrapper-footer {
    height: 65px;
    background: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0px 10px;
    border-top: 1px solid #ddd;
  }

  .modal {
    padding: 20px 0;

    .modal-content {
      margin: 20px 0;
    }
  }
}

.form-modal-widget {
  width: 600px;
  background: #fff;
  margin: 20px auto;
  border-radius: 5px;

  @media (max-width: 628px) {
    width: 95% !important;

    .row {
      flex-direction: column;
    }
  }

  @media (max-width: 500px) {
    width: 100% !important;
    margin: 0;
  }

  .form-modal-header {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    @media (max-width: 500px) {
      position: sticky;
      top: 0;
      z-index: 10;
      background: white;
    }
  }

  .form-modal-body {
    padding: 10px 20px;
    min-height: 200px;
    padding-bottom: 30px;
  }

  .form-modal-footer {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid #ddd;
    padding: 0px 20px;
  }
}

.modal {
  @media (max-width: 500px) {
    padding: 0 !important;
  }
}

#sideBartrue {
  left: 230px;

  @media (max-width: 768px) {
    left: 0;
  }

  .form-modal-widget {
    @media (max-width: 846px) {
      width: 500px;
    }

    @media (max-width: 768px) {
      width: 600px;
    }
  }
}
</style>
